import { resetPasswordRequest } from '../api.js';
import { getAuthCopy, translate } from '../i18n.js';

const html = String.raw;

const readHashParams = () => {
  const query = window.location.hash.split('?')[1] ?? '';
  return new URLSearchParams(query);
};

export const renderResetPasswordView = (container) => {
  const copy = getAuthCopy();
  const resetCopy = copy.reset ?? {};
  const params = readHashParams();
  const token = params.get('token') ?? '';
  const emailParam = params.get('email') ?? '';

  if (!token) {
    container.innerHTML = html`
      <div class="card stack">
        <h2>${resetCopy.title ?? 'Passwort zurücksetzen'}</h2>
        <p class="muted">${resetCopy.missingToken ?? 'Reset-Link ist ungültig oder fehlt.'}</p>
        <p class="muted small"><a href="#/forgot-password">${resetCopy.backToRequest ?? 'Neuen Link anfordern'}</a></p>
      </div>
    `;
    return;
  }

  container.innerHTML = html`
    <div class="card stack">
      <h2>${resetCopy.title ?? 'Passwort zurücksetzen'}</h2>
      <p class="muted">${resetCopy.subtitle ?? ''}</p>
      <form class="stack" id="reset-password-form">
        <label>
          ${resetCopy.emailLabel ?? copy.labels?.email ?? 'E-Mail'}
          <input type="email" name="email" required autocomplete="email" value="${emailParam}" />
        </label>
        <label>
          ${resetCopy.passwordLabel ?? 'Neues Passwort'}
          <input type="password" name="password" required minlength="6" autocomplete="new-password" />
        </label>
        <label>
          ${resetCopy.confirmLabel ?? 'Neues Passwort bestätigen'}
          <input type="password" name="confirmPassword" required minlength="6" autocomplete="new-password" />
        </label>
        <button type="submit">${resetCopy.submit ?? 'Passwort speichern'}</button>
        <p class="muted" id="reset-password-status"></p>
      </form>
      <p class="muted small"><a href="#/login">${resetCopy.backToLogin ?? 'Zurück zum Login'}</a></p>
    </div>
  `;

  const form = container.querySelector('#reset-password-form');
  const statusEl = container.querySelector('#reset-password-status');

  if (!form || !statusEl) {
    return;
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const data = new FormData(form);
    const email = data.get('email')?.toString() ?? '';
    const password = data.get('password')?.toString() ?? '';
    const confirmPassword = data.get('confirmPassword')?.toString() ?? '';
    if (!password || password.length < 6) {
      statusEl.textContent = resetCopy.passwordTooShort ?? copy.statuses?.passwordTooShort ?? 'Passwort ist zu kurz.';
      return;
    }
    if (password !== confirmPassword) {
      statusEl.textContent = resetCopy.passwordMismatch ?? copy.statuses?.passwordMismatch ?? 'Passwörter stimmen nicht überein.';
      return;
    }
    statusEl.textContent = resetCopy.saving ?? translate('common.loading');
    form.querySelectorAll('button').forEach((btn) => {
      btn.disabled = true;
    });
    try {
      await resetPasswordRequest({ email, token, password });
      statusEl.textContent = resetCopy.success ?? 'Passwort aktualisiert. Du kannst dich jetzt anmelden.';
      form.reset();
    } catch (error) {
      console.error(error);
      statusEl.textContent = error instanceof Error ? error.message : resetCopy.error ?? 'Passwort konnte nicht aktualisiert werden.';
    } finally {
      form.querySelectorAll('button').forEach((btn) => {
        btn.disabled = false;
      });
    }
  });
};
